module.exports = __webpack_public_path__ + "img/pin_exchange_red.99741766.svg";